<template>
  <div id="app" :class="appClassName">
    <header>
      <a @click="$router.push({ name: 'home' })">
          <svg svg-inline="" class="logo icon" focusable="false" role="presentation" xmlns="http://www.w3.org/2000/svg" width="132" height="42" viewBox="0 0 132 42"><path d="M34.64 24.44a7.724 7.724 0 0 0-2.813 2.812 12.423 12.423 0 0 1-7.591 5.825 12.422 12.422 0 0 1-9.488-1.25 12.425 12.425 0 0 1-5.825-7.591 12.425 12.425 0 0 1 1.25-9.487 12.422 12.422 0 0 1 7.592-5.826 12.42 12.42 0 0 1 9.486 1.25 12.562 12.562 0 0 1 4.576 4.575l-4.178 2.419a7.72 7.72 0 0 0-2.813-2.814 7.621 7.621 0 0 0-5.822-.767 7.626 7.626 0 0 0-4.66 3.576 7.622 7.622 0 0 0-.767 5.824 7.625 7.625 0 0 0 3.576 4.66 7.623 7.623 0 0 0 5.823.767 7.625 7.625 0 0 0 4.661-3.576 12.5 12.5 0 0 1 10.826-6.253H41v-8.012C41 5.308 36.692 1 31.428 1H10.573C5.308 1 1 5.308 1 10.572v20.856C1 36.692 5.308 41 10.573 41h20.855C36.692 41 41 36.692 41 31.428v-8.015l-2.527-.001a7.664 7.664 0 0 0-3.833 1.028m81.463-9.107v-1.206H121v18.665h-4.897v-1.125A10.333 10.333 0 0 1 111.002 33C105.487 33 101 28.738 101 23.5s4.487-9.5 10.002-9.5c1.862 0 3.607.487 5.1 1.333zm-5.472 12.741c2.654 0 4.813-2.052 4.813-4.574s-2.159-4.574-4.813-4.574c-2.655 0-4.816 2.052-4.816 4.574s2.16 4.574 4.816 4.574zM88.001 14C93.513 14 98 18.262 98 23.5S93.514 33 88 33s-10-4.262-10-9.5S82.486 14 88 14zm0 14.074c2.654 0 4.814-2.052 4.814-4.574s-2.16-4.574-4.815-4.574c-2.655 0-4.815 2.052-4.815 4.574s2.16 4.574 4.815 4.574zM126 33V9h5v24h-5zm-64.083-4.86a8.037 8.037 0 0 0 5.99.767c2.036-.53 3.739-1.8 4.793-3.575l4.3 2.413c-1.718 2.892-4.49 4.96-7.808 5.824a13.288 13.288 0 0 1-3.348.431c-2.229 0-4.428-.568-6.41-1.68-2.973-1.67-5.102-4.364-5.99-7.59-.89-3.224-.433-6.593 1.285-9.484 3.545-5.968 11.425-8.02 17.564-4.574a12.746 12.746 0 0 1 4.705 4.573l-4.296 2.419a7.84 7.84 0 0 0-2.893-2.813 8.04 8.04 0 0 0-5.988-.766c-2.036.53-3.738 1.8-4.792 3.574a7.438 7.438 0 0 0-.79 5.823c.546 1.979 1.852 3.633 3.678 4.658z" fill="#F0F0F0" fill-rule="evenodd"/></svg>
      </a>
      <div id="nav">
        <b-button v-if="$route.name !== 'join'"
          variant="coal-yellow"
          class="wide"
          @click="$router.push({ name: 'join' });"
        >
          Join
        </b-button>
      </div>
    </header>

    <div id="app-content">
      <transition name="fade" mode="out-in">
        <router-view/>
      </transition>
    </div>

    <div id="loader" v-if="$store.getters.loading">
      <img src="loader.gif"/>
    </div>

    <footer>
      <div class="footer">
        <b-row class="no-pad">
          <b-col cols="7" class="footer-text">
            © Coal 2019 -
            <a href="https://www.notion.so/wearecoal/Terms-Privacy-Policy-f965a13c53164cd4888555f048da9f87" target="_blank" class="footer-text">
              privacy
            </a>
          </b-col>
          <b-col class="text-right">
            <a ref="footerInstagramLinkClicked" href="https://instagram.com/we_are_coal/" target="_blank" class="footer-text">
              instagram
            </a>
            <a href="mailto:hello@wearecoal.com" target="_blank" class="ml-3 footer-text">
              mail
            </a>
          </b-col>
        </b-row>
      </div>
    </footer>

    <Cookies v-if="!$store.getters.useCookies"/>
  </div>
</template>

<script>
import Cookies from './components/Cookies.vue';

export default {
  name: 'App',
  mounted() {
  },
  components: {
    Cookies,
  },
  computed: {
    appClassName() {
      return this.$root.isMobile ? 'text-left mobile' : 'text-left desktop';
    },
  },
  methods: {
    acceptCookies() {
      this.$store.commit('useCookies');
    },
  },
};
</script>

<style lang="scss">
  @import './assets/css/variables';

  #app {
    position: relative;
    max-width: $app-width;
    margin: auto;

    display: flex;
    min-height: 100vh;
    flex-direction: column;

    #app-content {
      flex: 1;
    }

    header {
      width: 100%;
      height: 64px;
      min-height: 64px;
      background-color: $black;
      position: sticky;
      top: 0;
      left: 0;
      z-index: 999999;

      .header-text {
        color: #646464;
        font-family: $font-sans-serif-med;
        font-size: $font-size-small;
      }

      a:hover,
      a:hover *,
      a:hover svg path {
        color: #f0f0f0;
        fill: #f0f0f0;
      }

      .logo {
        position: relative;
        top: 16px;
        left: 0px;
        height: 32px;
      }

      #nav {
        position: absolute;
        top: 15px;
        right: 20px;

        a {
          display: inline-flex;

          &, & * {
            text-decoration: none;
          }

          svg {
            margin-top: -1px;
          }
        }
      }
    }

    footer {
      background-color: $black;
      width: calc(100% - 46px);
      padding: 64px 0 32px;
      margin: 0 auto;

      .footer {
        width: 100%;

        .footer-text {
          font-size: $font-size-small;
          color: #646464;
        }
      }
    }

    #app-content {
      margin: 26px $side-margin 0;
    }

    #loader {
      position: absolute;
      top: 64px;
      left: 0;
      width: 100%;
      height: 100%;
      z-index:9999999;
      background-color: $black;

      img {
        position: sticky;
        top: calc(50vh - 25px);
        left: calc(50vw - 25px);
      }
    }

    &.desktop {
      header {
        height: 145px;
      }

      .header-text {
        font-size: $font-size-regular;
      }

      #loader {
        top: 105px;
      }

      #app-content {
        margin: -20px 0 0 ;
        padding-bottom: 120px;
      }

      .logo {
      top: 32px;
      height: 42px;
      }

      #nav {
        top: 40px;
        right: 0px;
      }

      footer {
        position: fixed;
        bottom: 0px;
        left: 0px;
        width: 100%;
        padding-top: 32px;

        .footer {
          margin: 0 auto;
          max-width: $app-width;
        }
      }
    }
  }
</style>
